import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LeadsPage } from '@/features/leads/components/leads-page/leads-page';
import { LEAD_STATES } from '@/features/leads/constants/lead-status.constants';

const QUICK_FILTERS = [
  'mis_leads',
  'sin_asignar',
  'por_vencer',
  'renovaciones',
  'nuevos_semana',
  'cerrados_mes',
  // Sprint CRM 2026-05-17 — predicates del banner HOY
  'sin_contactar_7d',
  'followup_vencido',
  'cotizacion_sin_respuesta_3d',
  'sin_actividad_90d',
] as const;

export const leadsSearchSchema = z.object({
  estado: z.enum(LEAD_STATES).optional(),
  assignedUserId: z.string().optional(),
  origen: z.string().optional(),
  q: z.string().optional(),
  // selectedLeadId abre el panel lateral con detalle del lead.
  selectedLeadId: z.string().uuid().optional(),
  // editLeadId abre el FORM drawer (Empresa/Contacto/Comercial/Notas).
  editLeadId: z.string().uuid().optional(),
  page: z.coerce.number().int().min(1).optional(),
  quick: z.enum(QUICK_FILTERS).optional(),
  // CRM Premium PIEZA 7 — id de la saved view activa (tab seleccionado)
  viewId: z.string().uuid().optional(),
  // Nav tabs: pipeline | cerrados | sin_asignar | todos
  tab: z.enum(['pipeline', 'cerrados', 'sin_asignar', 'todos']).optional(),
  // Sprint CRM 2026-05-17: filtro de temperatura desde el dropdown
  // "Filtrar". hot=score>=70, warm=40-69, cold=<40.
  temperatura: z.enum(['hot', 'warm', 'cold']).optional(),
  // Sort persistente en URL — la tabla lee de aquí en vez de useState local.
  sortKey: z.enum(['createdAt', 'updatedAt', 'monto', 'empresa', 'estado']).optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
});

export type LeadsSearch = z.infer<typeof leadsSearchSchema>;

export const Route = createFileRoute('/_app/crm/leads/')({
  validateSearch: leadsSearchSchema,
  component: LeadsPage,
});
